const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const ATTR_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "gclid"];

export const getAttribution = () => {
  try { return JSON.parse(localStorage.getItem("vr_attr") || "{}"); } catch { return {}; }
};

const send = (path, payload) => {
  const blob = new Blob([JSON.stringify(payload)], { type: "application/json" });
  if (!(navigator.sendBeacon && navigator.sendBeacon(`${API}${path}`, blob))) {
    fetch(`${API}${path}`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload), keepalive: true }).catch(() => {});
  }
};

export const initTracking = () => {
  const params = new URLSearchParams(window.location.search);
  let attr = getAttribution();
  const fresh = {};
  ATTR_KEYS.forEach((k) => { const v = params.get(k); if (v) fresh[k] = v; });
  if (Object.keys(fresh).length) {
    attr = { ...attr, ...fresh };
    localStorage.setItem("vr_attr", JSON.stringify(attr));
  }
  let sid = localStorage.getItem("vr_sid");
  if (!sid) {
    sid = (window.crypto && window.crypto.randomUUID) ? window.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem("vr_sid", sid);
  }
  if (!sessionStorage.getItem("vr_visit_sent")) {
    sessionStorage.setItem("vr_visit_sent", "1");
    send("/track/visit", {
      session_id: sid,
      page: window.location.pathname + window.location.search,
      referrer: document.referrer || null,
      keyword: attr.utm_term || null,
      utm_source: attr.utm_source || null,
      utm_medium: attr.utm_medium || null,
      utm_campaign: attr.utm_campaign || null,
      utm_term: attr.utm_term || null,
      utm_content: attr.utm_content || null,
      gclid: attr.gclid || null,
    });
  }
};

let _lastPv = { path: null, t: 0 };
export const trackPageview = (path) => {
  const sid = localStorage.getItem("vr_sid");
  if (!sid) return;
  const now = Date.now();
  if (_lastPv.path === path && now - _lastPv.t < 2000) return;
  _lastPv = { path, t: now };
  send("/track/pageview", { session_id: sid, page: path });
};

export const trackCta = (ctaId, target) => {
  const attr = getAttribution();
  send("/track/click", {
    session_id: localStorage.getItem("vr_sid") || "unknown",
    cta_id: ctaId,
    page: window.location.pathname,
    target: target || null,
    keyword: attr.utm_term || null,
    utm_source: attr.utm_source || null,
    utm_medium: attr.utm_medium || null,
    utm_campaign: attr.utm_campaign || null,
    gclid: attr.gclid || null,
  });
  if (window.gtag) {
    window.gtag("event", "cta_click", {
      cta_id: ctaId,
      keyword: attr.utm_term || "(none)",
      campaign: attr.utm_campaign || "(none)",
      source: attr.utm_source || "(none)",
      link_url: target || "",
    });
  }
};
